import React from 'react'

const UnhandledError = () => (
  <React.Fragment>
    Unhandled error. Please help us by opening a{' '}
    <a href="https://github.com/lztll/adamoracle_v1/issues/new">
      bug report
    </a>
  </React.Fragment>
)

export default UnhandledError
